import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/layouts/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import CategoriesPage from "@/pages/admin/CategoriesPage";
import ProductsPage from "@/pages/admin/ProductsPage";
import BannersPage from "@/pages/admin/BannersPage";
import PaymentMethodsPage from "@/pages/admin/PaymentMethodsPage";
import StoreLocationsPage from "@/pages/admin/StoreLocationsPage";
import OrdersPage from "@/pages/admin/OrdersPage";
import UsersPage from "@/pages/admin/UsersPage";
import UserDetailsPage from "@/pages/admin/UserDetailsPage";

// Auth check
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("gasman_token");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="masters/categories" element={<CategoriesPage />} />
            <Route path="masters/products" element={<ProductsPage />} />
            <Route path="masters/banners" element={<BannersPage />} />
            <Route path="masters/payment-methods" element={<PaymentMethodsPage />} />
            <Route path="store-locations" element={<StoreLocationsPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
